"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip/Tooltip"));

var _elements = require("../../../styles/elements");

var _Table = require("../Table.styles");

var _icons = require("../../../assets/icons");

var _RowControls = require("./RowControls.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RowControls = function RowControls(_ref) {
  var value = _ref.value,
      deleteData = _ref.deleteData,
      onEdit = _ref.onEdit,
      className = _ref.className,
      name = _ref.name,
      sortable = _ref.sortable,
      deletionHint = _ref.deletionHint,
      disabledDeleteBtn = _ref.disabledDeleteBtn,
      disabledDeleteBtnHint = _ref.disabledDeleteBtnHint,
      disabled = _ref.disabled,
      dragHandle = _ref.dragHandle,
      disableReorder = _ref.disableReorder;
  var hasDeleteBtn = typeof deleteData === 'function';
  var hasEditBtn = typeof onEdit === 'function';
  var handleClickDelete = (0, _react.useCallback)(function () {
    deleteData(value);
  }, [deleteData, value]);
  var handleClickEdit = (0, _react.useCallback)(function () {
    onEdit(value);
  }, [onEdit, value]);
  var deleteBtn = (0, _react.useMemo)(function () {
    var deletionBtn = (0, _jsxRuntime.jsx)("span", {
      className: "grui ml-5",
      children: (0, _jsxRuntime.jsx)(_Button["default"], {
        type: "tertiary",
        size: "small",
        customIcon: (0, _jsxRuntime.jsx)(_icons.Trash, {}),
        onClick: handleClickDelete,
        disabled: disabledDeleteBtn
      })
    });

    if (deletionHint || disabledDeleteBtn) {
      return (0, _jsxRuntime.jsx)(_Tooltip["default"], {
        position: sortable ? 'top' : 'top-end',
        title: disabledDeleteBtn ? disabledDeleteBtnHint : deletionHint,
        maxWidth: sortable ? 200 : 300,
        strategy: "fixed",
        children: deletionBtn
      });
    }

    return deletionBtn;
  }, [deletionHint, disabledDeleteBtn, disabledDeleteBtnHint, handleClickDelete, sortable]);
  if (disabled) return null;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _RowControls.styles.base,
    className: className,
    children: [hasEditBtn && (0, _jsxRuntime.jsx)(_Button["default"], {
      type: "tertiary",
      size: "small",
      customIcon: (0, _jsxRuntime.jsx)(_icons.Edit, {}),
      onClick: handleClickEdit
    }), hasDeleteBtn && deleteBtn, sortable && (0, _jsxRuntime.jsx)(_Tooltip["default"], {
      position: "top-end",
      title: "You can only reorder ".concat(name, " when all ").concat(name, " are shown and in normal order. You currently have a filter, search or sorting applied."),
      strategy: "fixed",
      disabled: !disableReorder,
      children: (0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread(_objectSpread({
        type: "button",
        css: [_elements.button.styles.link, _Table.styles.handle, process.env.NODE_ENV === "production" ? "" : ";label:RowControls;"],
        className: (0, _clsx["default"])('grui block reorder-handle', hasEditBtn && hasDeleteBtn ? 'ml-10' : 'ml-5')
      }, !disableReorder && (dragHandle === null || dragHandle === void 0 ? void 0 : dragHandle.attributes) || {}), !disableReorder && (dragHandle === null || dragHandle === void 0 ? void 0 : dragHandle.listeners) || {}), {}, {
        children: (0, _jsxRuntime.jsx)(_icons.Grab, {})
      }))
    })]
  });
};

RowControls.propTypes = {
  /**
   * The cell data
   */
  value: _propTypes.string.isRequired,

  /**
   * Custom function from Table for updating data
   */
  deleteData: _propTypes.func,

  /**
   * Custom function from Table for handling clicking on Edit button
   */
  onEdit: _propTypes.func,
  className: _propTypes.string,

  /**
   * Table name
   */
  name: _propTypes.string,
  sortable: _propTypes.bool,
  deletionHint: _propTypes.string,
  disabledDeleteBtn: _propTypes.bool,
  disabledDeleteBtnHint: _propTypes.string,
  disabled: _propTypes.bool,
  dragHandle: (0, _propTypes.shape)({
    attributes: (0, _propTypes.shape)({}),
    listeners: (0, _propTypes.shape)({})
  }),
  disableReorder: _propTypes.bool
};
RowControls.defaultProps = {
  deleteData: function deleteData() {},
  onEdit: undefined,
  className: undefined,
  name: '',
  sortable: false,
  deletionHint: undefined,
  disabledDeleteBtn: false,
  disabledDeleteBtnHint: 'This item cannot be deleted',
  disabled: false,
  dragHandle: null,
  disableReorder: false
};
var _default = RowControls;
exports["default"] = _default;
//# sourceMappingURL=RowControls.js.map